import React from 'react';
import { Icon } from './Icon.js';
export const IconGridLayoutColsFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("rect", { x: "10", y: "2", width: "6", height: "14", rx: "2.25", ry: "2.25", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" }),
        React.createElement("rect", { x: "2", y: "2", width: "6", height: "14", rx: "2.25", ry: "2.25", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconGridLayoutColsFill18.js.map